import { DEV } from "solid-js"
import { round } from "../../../core/util/math/Math"
import { freeze } from "../../../core/util/Object"

/**
 * Computes spatial weights for a normalized point (x, y) on a square tile.
 * nx and ny are already normalized so x ∈ [‑halfSize, halfSize].
 */
export default function createXYCacheFactory<T>(
  fn: (x: number, y: number) => T,
  resolution: number = 1e-3,
): (x: number, y: number) => T {
  const cache = new Map<string, T>()

  return function (x: number, y: number): T {
    x = round(x / resolution) * resolution
    y = round(y / resolution) * resolution
    const key = `${x},${y}`
    let result = cache.get(key)
    if (!result) {
      result = fn(x, y)
      if (DEV) {
        freeze(result)
      }
      cache.set(key, result)
    }
    return result
  }
}
